import * as rk from '../../localization/resourceKeys';

interface VerifyRememberMeErrorDetails {
  ErrorCode?: string;
}

interface VerifyRememberMeResultLike {
  reasonCode?: string;
  errors?: VerifyRememberMeErrorDetails;
}

export interface VerifyRememberMeErrorBannerKeys {
  titleKey?: string;
  messageKey: string;
}

export const isVerifyRememberMeLockout = (
  verifyResult?: VerifyRememberMeResultLike,
  reasonCode?: string,
): boolean => {
  const normalizedReasonCode = reasonCode || verifyResult?.reasonCode;
  const errorCode = verifyResult?.errors?.ErrorCode;

  return errorCode === 'badRequest_accountLocked' || normalizedReasonCode === 'account_locked';
};

export const getVerifyRememberMeErrorBannerKeys = (
  verifyResult?: VerifyRememberMeResultLike,
  reasonCode?: string,
): VerifyRememberMeErrorBannerKeys => {
  if (isVerifyRememberMeLockout(verifyResult, reasonCode)) {
    return {
      titleKey: rk.TITLE_LOCKOUT_ERROR,
      messageKey: rk.TEXT_LOCKOUT_ERROR,
    };
  }

  return {
    messageKey: rk.ERROR_MYVW_VERIFY_REMEMBER_ME_FAILED,
  };
};
